/** Shared scrollbar helpers. */
import { IPD_COLORS } from "./ipdColors";

export const hideScrollbarSx = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const thinScrollbarSx = {
  scrollbarWidth: 'thin',
  scrollbarColor: `${IPD_COLORS.scrollbarThumb} transparent`,
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: IPD_COLORS.scrollbarThumb,
    borderRadius: 8,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: IPD_COLORS.scrollbarThumbHover,
  },
};
